module.exports = __webpack_public_path__ + "img/195.b2297068.jpg";